import { useState } from "react";

import styled from "styled-components";

const LeftButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#253569"
    >
      <polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293" />
    </svg>
  );
};

const RightButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#253569"
    >
      <polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707" />
    </svg>
  );
};

const OuterContainer = styled.div`
  width: 100vw;
  // height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: erstoria;
  color: #253569;
  background-color: rgb(255, 254, 239);
  text-align: center;
  margin-bottom: 100px;
  margin-top: 100px;
  // background-color: red;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 6fr 1fr;
  // background-color: green;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  /* If you want to implement it in very old browser-versions */
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */

  /* The rule below is not implemented in browsers yet */
  -o-user-select: none;

  /* The rule below is implemented in most browsers by now */
  user-select: none;

  background-color: none;
  -webkit-tap-highlight-color: transparent;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background-color: yellow;
`;

const H3 = styled.h3`
  font-family: Karla;
  font-size: 2em;
  font-weight: 400;
  width: 80%;
  text-align: center;

  @media (max-width: 640px) {
    font-size: 1.3em;
  }

  @media (max-width: 400px) {
    font-size: 1.1em;
  }
`;

const Paragraph = styled.p`
  font-family: Karla;
  font-size: 1.6em;
  font-weight: 400;
  color: #253569;
  text-align: center;

  @media (max-width: 640px) {
    font-size: 1em;
  }

  @media (max-width: 400px) {
    font-size: 0.8em;
  }
`;

const TestimonialData = [
  {
    content: `“Working with Cianna was an absolute joy. She effortlessly edited a series of 
    videos for my online course, made any changes I requested without question and delivered 
    them on time and to a high standard. She was responsive, efficient and didn’t take too 
    long to reply. I would be very happy to recommend Cianna as an editor.”`,
    name: "Jules Francis - Integrative Health Coach",
    href: "https://uk.linkedin.com/in/jules-francis",
  },
  {
    content: `"I highly recommend Cianna for her work in video production. I worked 
              with Cianna on the feature documentary 'Todo por jugar'. During this
              time I worked with Cianna as camera operators and always found her to 
              be extremely professional, hard working and reliable. I also had the 
              opportunity to sit in with Cianna during editing sessions and was 
              impressed by her attention to detail and creative approach to each scene 
              she worked on. A real team player, Cianna always went above and beyond
              to make sure the production was a success."`,
    name: "Samantha Keon - Documentary Filmmaker and Assistant Editor",
    href: "https://www.linkedin.com/in/samantha-keon-filmmaker/",
  },
  {
    content: `“We've been incredibly fortunate to have Cianna working alongside the Swwim team. 
    Her infallible can-do attitude has been a real asset while working on marketing reports and 
    digital content projects. Her quick and clear communication keeps projects on track, while 
    her friendly demeanour makes her a joy to work with. I highly recommend Cianna for her 
    exceptional skills and ability to integrate with any team seamlessly.”`,
    name: "Emma Tester - Digital Marketing Manager at Swwim Social Media Agency",
    href: "https://www.linkedin.com/in/emma-tester-b76a57a8/",
  },
  {
    content: `“...Cianna performs at the highest professional and technical levels. Her friendly 
    nature, confidence and competency has been invaluable and most appreciated. Cianna has a 
    completely open attitude to learning and figuring out any new software or programme, she simply 
    keeps working until she finds the best solution. She is a calm, thorough and focused worker…”`,
    name: "Angela Murphy - Co-Founder and Executive Producer at HAPPY.film and formerly at NZIFF",
    href: "https://www.linkedin.com/in/angela-murphy-5871b318",
  },
  {
    content: `“...It was a pleasure to work with Cianna. I quickly identified her as a confident individual
     with excellent interpersonal skills and the ability to lead a team. Her personality and confidence 
     provides her with tools that cannot be taught, and serve her well in the working environment 
     and film industry...”`,
    name: "Grace Baird - Support Team Manager at CINECITY Brighton Film Festival",
    href: "https://www.linkedin.com/in/gracebaird/",
  },
  {
    content: `“...Cianna was a key member of our team during the festival. Cianna has a really positive and 
    personable manner when dealing with her team and the public. I would recommend her whole-heartedly for 
    any positions in a Film Festival or Film related organisation...”`,
    name: "Sara Duffy - Event Manager at CINECITY Brighton Film Festival",
    href: "https://www.linkedin.com/in/sara-duffy-a33bb636/",
  },
  {
    content: `“...Cianna was extremely helpful, motivated, and delightful to work with. She demonstrated 
    her ability to provide excellent customer service, interpersonal and communication skills...”`,
    name: "Sophia D'Urso - Volunteers Coordinator at Melbourne Fringe Festival",
    href: "https://www.linkedin.com/in/sophiadurso/",
  },
];

const Testimonials = () => {
  const [selected, setSelected] = useState(0);
  return (
    <OuterContainer>
      <Grid>
        <Button
          onClick={(evt) => {
            evt.preventDefault();
            setSelected(
              selected <= 0
                ? TestimonialData.length - 1
                : (selected - 1) % TestimonialData.length
            );
          }}
        >
          <LeftButton />
        </Button>
        <Content>
          <H3>{TestimonialData[selected].content}</H3>
          <Paragraph>
            <a
              style={{
                color: "#253569",
              }}
              href={TestimonialData[selected].href}
              target="_blank"
            >
              {TestimonialData[selected].name}
            </a>
          </Paragraph>
        </Content>
        <Button
          onClick={(evt) => {
            evt.preventDefault();
            setSelected((selected + 1) % TestimonialData.length);
          }}
        >
          <RightButton />
        </Button>
      </Grid>
    </OuterContainer>
  );
};

export default Testimonials;
